import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { createRole, roleQueryKeys } from '../api/roles.api';
import type { CreateRolePayload } from '../types/role.types';

export function useCreateRole(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateRolePayload) => createRole(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: roleQueryKeys.all() });
      toast.success('Role created successfully');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to create role');
    },
  });
}
